import { render, staticRenderFns } from "./CruiseDetailSlideRight.vue?vue&type=template&id=02441590&scoped=true&"
import script from "./CruiseDetailSlideRight.vue?vue&type=script&lang=js&"
export * from "./CruiseDetailSlideRight.vue?vue&type=script&lang=js&"
import style0 from "./CruiseDetailSlideRight.vue?vue&type=style&index=0&id=02441590&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02441590",
  null
  
)

export default component.exports